import React from 'react';
import {Team} from '../../interfaces';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Control, Controller, FieldValues} from 'react-hook-form';
import FormCheckbox from './FormCheckbox';

interface Props {
  teams?: Team[];
  control: Control<FieldValues>;
  name: string;
  label?: string;
  required?: boolean;
}

const TeamFilter: React.FC<Props> = ({
  teams,
  control,
  name,
  required,
  label,
}) => {
  const {t} = useTranslation();

  // if there is only one player, don't show the selector
  if ((teams ?? []).length === 0) {
    return null;
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? `${label || 'This field'} is required` : undefined,
      }}
      render={() => (
        <Box sx={{mb: 2}}>
          <Box>
            <FormCheckbox
              control={control as unknown as Control<FieldValues>}
              name={`teamIds.individual`}
              label={t('general.individual')}
            />
            {(teams ?? []).map(team => (
              <FormCheckbox
                key={team.id}
                control={control as unknown as Control<FieldValues>}
                name={`teamIds.${team.id}`}
                label={team.displayName}
              />
            ))}
          </Box>
        </Box>
      )}
    />
  );
};

export default React.memo(TeamFilter);
